import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { UpdateSpinWheelPrizesEntity } from '../../domain/entities/UpdateSpinWheelPrizesEntity'

export class UpdateSpinWheelPrizesModel extends UpdateSpinWheelPrizesEntity {
  constructor(dataDto: UpdateSpinWheelPrizesEntity) {
    super()
    mapEntityProperties<UpdateSpinWheelPrizesModel>(this, dataDto, {
      exclude: ['prizes'],
      map: {
        prizes: dataDto.prizes?.map((prize) => {
          return {
            prizeId: prize.id,
            probability: prize.probability
          }
        })
      }
    })
  }
}
